module.exports = __webpack_public_path__ + "static/media/home.0904fe35.svg";